import img1 from '../img/mobilecover/1.png'
import img2 from '../img/mobilecover/2.png'
import img3 from '../img/mobilecover/3.png'
import img4 from '../img/mobilecover/4.png'
import img5 from '../img/mobilecover/5.png'
import img6 from '../img/mobilecover/6.png'

const creater = {
  Name: ['Rishi'],
}
const type = {
  Type: ['hard', 'soft'],
}

export const coverdata = [
  {
    id: 1,
    img: `${img1}`,
    name: `Tom and Jerry`,
    creater: `${creater.Name[0]}`,
    type: `${type.Type[0]}`,
    mrp: '₹499',
    price: '₹299',
    itemNumber: 'mbc0011',
  },
  {
    id: 2,
    img: `${img2}`,
    name: `Music Panda`,
    creater: `${creater.Name[0]}`,
    type: `${type.Type[0]}`,
    mrp: '₹499',
    price: '₹299',
    itemNumber: 'mbc0012',
  },
  {
    id: 3,
    img: `${img3}`,
    name: `Maths`,
    creater: `${creater.Name[0]}`,
    type: `${type.Type[0]}`,
    mrp: '₹499',
    price: '₹299',
    itemNumber: 'mbc0013',
  },
  {
    id: 4,
    img: `${img4}`,
    name: `Glasses and Moustache`,
    creater: `${creater.Name[0]}`,
    type: `${type.Type[0]}`,
    mrp: '₹499',
    price: '₹349',
    itemNumber: 'mbc0014',
  },
  {
    id: 5,
    img: `${img5}`,
    name: `Flower Pattern`,
    creater: `${creater.Name[0]}`,
    type: `${type.Type[0]}`,
    mrp: '₹499',
    price: '₹299',
    itemNumber: 'mbc0015',
  },
  {
    id: 6,
    img: `${img6}`,
    name: `Hope 2021`,
    creater: `${creater.Name[0]}`,
    type: `${type.Type[0]}`,
    mrp: '₹499',
    price: '₹299',
    itemNumber: 'mbc0016',
  },
]
